// extracted by mini-css-extract-plugin
export default {"serviceCard":"ServiceCard_serviceCard__QXqNN","icon":"ServiceCard_icon__f2GlI","description":"ServiceCard_description__M+uDq"};